export default import.meta.ROLLDOWN_FILE_URL_i2ywl_YzKp2MjtOEr7ngzA